import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridContainer from "cabinet/components/ui/Grid/GridContainer";
import GridItem from "cabinet/components/ui/Grid/GridItem";
import Card from "cabinet/components/ui/Card/Card";
// style
import styles from "assets/jss/material-kit-react/views/signupPage";
// background
import image from "assets/img/bg7.jpg";

const useStyles = makeStyles(styles);

const Signup = (props) => {
	const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
	setTimeout(() => {
		setCardAnimation("");
	}, 700);
	const classes = useStyles();
	return (
		<div>
			<div
				className={classes.pageHeader}
				style={{
					backgroundImage: `url(${image})`,
					backgroundSize: "cover",
					backgroundPosition: "top center",
				}}>
				<div className={classes.container}>
					<GridContainer justifyContent="center">
						<GridItem xs={12} sm={12} md={8}>
							<Card className={classes[cardAnimaton]}>{props.children}</Card>
						</GridItem>
					</GridContainer>
				</div>
			</div>
		</div>
	);
};

export default Signup;
